"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Superuser = function Superuser(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return _react.default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), _react.default.createElement("path", {
    d: "M20.863 14.479c-1.48.421-2.489 1.287-2.489 2.716v4.081c0 3.048-2.907 2.714-6.517 2.714h-.555c-.225 0-.359-.084-.359-.28v-1.398c0-.194.12-.279.345-.279h.45c2.16 0 3.675.475 3.675-1.26v-3.917c0-1.199.84-2.88 2.521-3.493.119-.031.135-.085.135-.141s-.03-.139-.135-.195c-1.53-.7-2.521-1.844-2.521-3.217V5.385c0-1.707-1.5-3.412-3.659-3.412h-.451c-.225 0-.33-.084-.33-.279V.301c0-.195.15-.281.375-.281h.556c3.6 0 6.54 2.572 6.54 5.62v3.72c0 1.409 1.004 2.22 2.52 2.744.556.165.869.196.869.646v1.17c.03.256-.239.375-.914.57l-.056-.011zM8.092 23.97h-5.59c-.225 0-.336-.056-.336-.252V.279c0-.164.104-.279.33-.279H8.03c.226 0 .36.084.36.279v1.455c0 .195-.121.252-.346.252H5.572c-.305 0-.42.111-.42.307v19.41c0 .196.115.27.367.27h2.517c.226 0 .363.076.363.255v1.484c.029.166-.084.255-.308.255v.003zm4.875-13.034h-1.485c-.362 0-.642-.281-.642-.59V9.003c0-.335.307-.585.642-.585h1.485c.359 0 .642.277.642.585v1.343c0 .336-.31.588-.645.588l.003.002z"
  }));
};

Superuser.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes.default.string,

  /**
   * The size of the Icon.
   */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Superuser.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Superuser;
exports.default = _default;